import * as ImagePicker from 'expo-image-picker';

/**
 * Standard options for picking a profile avatar: square crop + 80% quality.
 * Shared by the sign-up avatar flow and the edit-profile-photo (web) flow so
 * every avatar entry point produces a consistently-sized, cropped image.
 *
 * Note: `allowsEditing`, `aspect` and `quality` are honoured on native only —
 * the `expo-image-picker` web backend ignores them, so web uploads the file
 * as-is, uncropped and uncompressed.
 */
export const AVATAR_IMAGE_PICKER_OPTIONS: ImagePicker.ImagePickerOptions = {
  mediaTypes: ['images'],
  allowsEditing: true,
  aspect: [1, 1],
  quality: 0.8,
};

export const pickAvatarFromLibrary = () =>
  ImagePicker.launchImageLibraryAsync(AVATAR_IMAGE_PICKER_OPTIONS);
